var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo-14vzn-page"}},[_c('DemoVzn14')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }